import React, { useEffect, useState } from "react";
import controllerState from "../../service/state/controller.state";
import { Button_v1 } from "../../UI/components/Button_v1";
import { TagControllerFilter } from "../controllers/TagControllerFilter";
import { observer } from "mobx-react-lite";

export const FilterLogs = observer(() => {
  // const [valueTag, setValueTag] = useState("");
  // const [valueFromDate, setValueFromDate] = useState(""); // c
  // const [valueToDate, setValueToDate] = useState(""); // по
  const [resetDate, setResetDate] = useState(false);

  const resetFilter = () => {
    setResetDate(true);
    controllerState.setParameters("tag_value", "");
    controllerState.setParameters("data_from", "");
    controllerState.setParameters("data_to", "");
    // setValueTag("");
    // setValueFromDate("");
    // setValueToDate("");
    controllerState.setParameters(
      "history_date",
      controllerState.history_date_original,
    );
    controllerState.setParameters(
      "history_controller",
      controllerState.history_controller_original,
    );
  };

  useEffect(() => {
    console.log(123123123123);
    if (resetDate) {
      return setResetDate(false);
    }
    controllerState.tagHistoryFilter();
  }, [
    controllerState.tag_value,
    controllerState.data_from,
    controllerState.data_to,
    resetDate,
  ]);

  return (
    <div className="filter_logs_conteiner log_item_date_cell">
      <div className="conteiner_filter_v1">
        <span className="text_filter_v1">Дата начала: </span>
        <input
          type="datetime-local"
          onChange={(e) =>
            controllerState.setParameters("data_from", e.target.value)
          }
          value={controllerState.data_from}
          className="inp_filter_v1"
          max={controllerState.data_to}
        />
      </div>
      <div className="conteiner_filter_v1">
        <span className="text_filter_v1">Дата окончания: </span>
        <input
          type="datetime-local"
          onChange={(e) =>
            controllerState.setParameters("data_to", e.target.value)
          }
          value={controllerState.data_to}
          className="inp_filter_v1"
          min={controllerState.data_from}
        />
      </div>
      <label className="conteiner_filter_v1">
        <span className="text_filter_v1">Поиск по тегу: </span>
        <input
          type="text"
          className="inp_filter_v1"
          onChange={(e) =>
            controllerState.setParameters("tag_value", e.target.value)
          }
          value={controllerState.tag_value}
          placeholder="Введите имя тега..."
        />
      </label>
      <TagControllerFilter />
      <Button_v1 name="Сбросить фильтры" onClick={resetFilter} />
    </div>
  );
});
